import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { SitesTableObject } from 'src/app/models/orders/order-details-sites/sites-table/sites-object.model';
import { SitesService } from 'src/app/services/api/orders/obtain-order-details-sites.service';
import { SitesObject } from 'src/app/models/orders/order-details-sites/sites-tab-object-model';
import { isNullOrUndefined } from 'util';
import { Subscription } from 'rxjs';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';

@Component({
  selector: 'app-order-details-sites',
  templateUrl: './order-details-sites.component.html',
  styleUrls: ['./order-details-sites.component.css'],
})
export class OrderDetailsSitesComponent implements OnInit, OnChanges {

  _summary: OrderSummary;
  @Input()
  get summary(): any {
    return this._summary;
  }
  set summary(value: any) {
    this._summary = value;
    this.ngOnInit();
  }
  _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }
  @Input() isps: any[];

  previousId: string;

  sitesTable: Array<SitesTableObject>;
  sites: Array<SitesObject>;
  dataSource: MatTableDataSource<SitesTableObject>;
  dataSourceId: number = 0;
  columnsToDisplay: string[] = ['name', 'role', 'numberOfContacts', 'addressFormat'];
  hasLoadedSites: boolean;

  constructor(private sitesService: SitesService,
    private ordersService: OrdersService,
    private notificationsService: NotificationsService) {

  }

  ngOnInit() {
    if (this._params && this._summary && (this.previousId !== this._summary.id || this._summary.isReload)) {
      this.hasLoadedSites = false;
      this.previousId = this._summary.id;
      this.loadSitesData();
    }
  }


  ngOnChanges(changes: SimpleChanges): void {

  }

  private isSameCard(itemChanged: SimpleChange) {
    if (!isNullOrUndefined(itemChanged.previousValue)) {
      if (itemChanged.currentValue.orderId === itemChanged.previousValue.orderId) {
        return true;
      }
    }
    return false;
  }

  private loadSitesData(): void {
    if (!this.hasLoadedSites) {
      this.sites = new Array<SitesObject>();
      this.sitesTable = new Array<SitesTableObject>();
      this.dataSource = new MatTableDataSource<SitesTableObject>();
      this.loadSitesInfo();
    } else {
      this.setSites(this.sites);
    }
  }


  private loadSitesInfo() {
    this.clearSites();
    if (this._params.type === 'product') {
      this.ordersService.getProductSites(this._summary.id).subscribe(
        (sites: Array<SitesObject>) => {
          this.setSites(sites);
          this.hasLoadedSites = true;
        },
        (error) => {
          this.notificationsService.showNotification('No se han podido recuperar sitios para esta orden', NotificationLevel.ERROR);
        }
      );
    } else {
      this.ordersService.getServiceSites(this._summary.id).subscribe(
        (sites: Array<SitesObject>) => {
          this.setSites(sites);
          this.hasLoadedSites = true;
        },
        (error) => {
          this.notificationsService.showNotification('No se han podido recuperar sitios para esta orden', NotificationLevel.ERROR);
        }
      );
    }

  }

  private setSites(sites: Array<SitesObject>) {
    this.clearSites();
    this.sites = sites;
    for (const site of sites) {
      this.sitesTable.push(site.getSitesTable());
    }
    this.displaySitesTable(this.sitesTable);
    this.changeDataSourceId(0);
  }

  private displaySitesTable(sitesTable: SitesTableObject[]) {
    this.dataSource = new MatTableDataSource<SitesTableObject>(sitesTable);
  }

  private clearSites() {
    this.sitesTable = new Array<SitesTableObject>();
  }
  public changeDataSourceId(dataSourceId: number) {
    this.dataSourceId = dataSourceId;
  }
}
